import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';
import { messages } from '../../constants/messages';
import { messages_ar } from '../../constants/messages_ar';
import { messages_kk } from '../../constants/messages_kk';
import { messages_fr } from '../../constants/messages_fr';
import { messages_sv } from '../../constants/messages_sv';
import { messages_no } from '../../constants/messages_no';
import { messages_vi } from '../../constants/messages_vi';
import { messages_tr } from '../../constants/messages_tr';
import { messages_it } from '../../constants/messages_it';
import { messages_es } from '../../constants/messages_es';
import { messages_cy } from '../../constants/messages_cy';
import { messages_de } from '../../constants/messages_de';
import { messages_el } from '../../constants/messages_el';
import { messages_cz } from "../../constants/messages_cz";
import { messages_pt } from '../../constants/messages_pt';
import { messages_lt } from '../../constants/messages_lt';
import { showMessage } from '../../actions/FlashMessageActions';
import {isGamiclub} from './../../constants/isGamiclub'
import { Container, Row, Col, Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle, Button } from 'reactstrap';

import StarRatingComponent from 'react-star-rating-component';

import * as vars from '../../constants/variables';

import { getCategorygame } from "../../actions/GamesActions";
import { getCategoryDetail } from "../../actions/CategoryActions";
import { show, hide } from "../../actions/ActivityIndicatorActions";

import { console_log, parseQueryString, appendUid } from '../../utils/helper';
import { FormattedMessage } from 'react-intl';
import { config,lang } from '../../constants/domainConfig';
import { isCategoryAllowed } from "../../constants/restrictedCategories";
import { sendData } from '../../analytics/sendData';
import {filterGames} from './../../utils/helper'
import { isGameflares, isGamiway } from '../../constants/productCondition';

let msg;

class GameList extends Component {
    constructor(props) {

        super(props);

        this.state = {
            activeTab: '1',
            rating: 0,
            isValid: false,
            errorMessage: '',
            category: {},
            loading: true
        };

        this.openGame = this.openGame.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        sendData('', this.state.category.categoryName, this.state.category.categoryTypeName, 'viewed', { page: 'game list'} );
    }

    onStarClick(nextValue, prevValue, name) {
        this.setState({rating: nextValue});
    }

    componentWillMount() {
        let categoryId = this.props.match.params.categoryId;
        if(this.props.games.categoryGames.length != 0) {
            if (this.props.games.categoryGames[0].categoryId != this.props.match.params.categoryId) {
                this.props.show();
                let uid = this.props.access.uid;
                this.getGames(categoryId, uid);
            }
        }else {
            this.props.show();
            let uid = this.props.access.uid;
            this.getGames(categoryId, uid);
        }
        this.getCategoryDetail(categoryId);
        const searchContainer = document.querySelector("#search-container");

            if(searchContainer != null){
                if (searchContainer.classList.contains('search-toggle')) {
                    searchContainer.classList.toggle("search-toggle");
                }
            }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.categoryId != nextProps.match.params.categoryId) {
            this.getGames(nextProps.match.params.categoryId, this.props.access.uid);
            this.getCategoryDetail(nextProps.match.params.categoryId);
        }
    }

    getGames(categoryId, uid) {
        return new Promise((resolve, reject) => {
            axios.get(vars.BASE_URL + '/getGames?categoryId=' + categoryId + '&uid=' + uid)
                .then((response) => {
                    if (response.data.success) {
                        response.data.data = response.data.data.filter((game) => isCategoryAllowed(game.categoryName));
                        if ( !(config.subDomain == 'tr' || config.subDomain == 'no') ) {
                            response.data.data = response.data.data.filter(game => {
                                return (game.gameTitle != "Trusted Tarot" && game.gameTitle != "Coffee Reading");
                            })
                        }
                        if (config.subDomain == 'no') response.data.data =
                            response.data.data
                                .map(game => {
                                    return game.gameId == 455 ? { ...game, gameTitle: 'Coffee Reading' } : game
                        })
                        if(config.subDomain != 'tr'){
                            response.data.data = response.data.data.filter((game) => {
                                return game.gameTitle != 'Okey'
                            })
                        }
                        if(config.subDomain === 'eg'){
                            const excluded_games = ['Santa Claus The Pervert Part 1', 'Place your bets! GTA is getting a real virtual casino', 'Dargavs Welcome to the City of the Dead', 'King Bacon Vs Vegans', 'Jackpot', 'Christmas Night Of Horror', 'High Fly Valentine', 'Horoscope', 'Sacra Terra Kiss Of Death', 'Haunted Legends Undertaker', 'Stereotypo'];
                            response.data.data = response.data.data.filter((game) => {
                                return excluded_games.indexOf(game.gameTitle) < 0
                            })
                        }
                        if(!(config.subDomain === 'gh' || config.subDomain === 'ci')){
                            response.data.data = response.data.data.filter((game) => {
                                return  game.gameTitle !='Fidget Pop It'
                            }) 
                        }
                        if(config.subDomain !== 'demo'){
                            const excluded = ['Balancer Ball 3D','Bottle Knock Down','Brain For Monster Truck','Bull Fight','Dogs Quiz','Forsake The Rake','Fruit Slice','Horse Quiz','Knock Down','Physics Line','Pixel Art','Sheep Fight','Slenderman Must Die Abandoned Graveyard','Tough Muscle Man','Unicorn Dash'];
                            response.data.data=response.data.data.filter((game)=>{
                                return excluded.indexOf(game.gameTitle) < 0
                            })
                        }
                        if(config.subDomain === 'demo'){
                            const excluded = ['Box Race','Pacman',"Don't Miss",'Earth Attack','Memory Game','Mathematic','Office Horror Story','Rise Up','Shadow Ninja','Square Adventure','Super Color Lines','NINJA CLAN','Fidget Spinner','Snake Attack','King Bacon Vs Vegans','CATS VS DOGS','Legend Of The Samurai','Zombo','CANDY GIRL','Flappy Bird Multiplayer','RUN, VOVAN, RUN',' BOX TOWER','Connect 4','Four Colors','Math Game','Slice Fruit','Goose Game'];
                            response.data.data=response.data.data.filter((game)=>{
                                return excluded.indexOf(game.gameTitle) < 0
                            })
                        }
                        if(config.subDomain !== 'pe'){
                            const excluded = ['Caller ID'];
                            response.data.data=response.data.data.filter((game)=>{
                                return excluded.indexOf(game.gameTitle) < 0
                            })
                        }
                        if(config.subDomain!== 'pe' && config.subDomain!== 'tr'){
                            const excluded = ['Photo Text Editor','Photo Editor Application','Pic Shop','Retro Cam Pro','Facial Twin Editor','Valentine Love Mesh','Love Photo','Wild Side App'];
                            response.data.data=response.data.data.filter((game)=>{
                                return excluded.indexOf(game.gameTitle) < 0
                            })
                        }
                        if(config.subDomain!== 'gr' && config.subDomain!== 'cz' && config.subDomain!== 'ch' && config.subDomain!== 'fr'){
                            const excluded = ['PDF Merger', 'QR Scanner'];
                            response.data.data=response.data.data.filter((game)=>{
                                return excluded.indexOf(game.gameTitle) < 0
                            })
                        }
                        if (config.subDomain === 'pe') {
                            const excluded = ['Brain it on the truck', 'Pacman', 'Earth Attack','Brain For Monster Truck'];
                            response.data.data = response.data.data.filter((game) => {
                               if (game.categoryName === 'Adventure' && game.gameTitle === 'Rise Up') {
                                    return false
                                }
                                return excluded.indexOf(game.gameTitle) < 0
                            })
                        }
                    }
                    this.props.getCategorygame(response.data)
                    this.setState({loading: false})
                    resolve();
                })
                .catch((error) => {
                    this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
                    this.setState({loading: false})
                    reject(error);
                });
        })
        
    }
    translateCat(categoriesArr, lang) {
        let translatedCatArr = categoriesArr.map(cat => {
            let englishCat = ["Premium Games", "Action", "Adventure", "RPG", "Virtual Reality", "Arcade", "Racing", "Sports"];
            let arabicCat = ["العاب مميزه", "الاكشن", "المغامرات", "العاب ار بي جي", "الواقع الافتراضي", "مغامرات", "سباق", "الرياضه"];
            let kazakhCat = ["Премиум игры", "Экшн", "Приключения", "RPG", "Виртуальная реальность", "Аркады", "Гонки", "Спорт"];
            let frenchCat = ["Jeux Premium", "Action", "Aventure", "RPG", "Réalité virtuelle", "Arcade", "Course", "Sports" ];
            let swedishCat = ["Premium-spel", 'Action', 'Äventyr', 'RPG', 'Virtual Reality', 'Arkad', 'Racing', 'Sporter'];
            let belgiumCat = ["Premium spelletjes", "Actie", "Avontuur", "RPG", "Virtuele realiteit", "Arcade", "Racen", "Sport"];
            let norwayCat = ["Premium-spill", "Action", "Eventyr", "RPG", "Virtuell virkelighet", "Arkade", "Racing", "Sport"];
            let vietnamCat = ["Games độc quyền", "Hành động", "Phiêu lưu", "RPG", "Thực tế ảo", "Nhập vai", "Đua xe", "Thể thao"];
            let turkeyCat = ["Premium Oyunlar   ", "Aksiyon", "Macera", "RPG", "Sanal Gerçeklik", "Arcade oyun", "Yarış ", "Spor"];
            let spanishCat = ["Juegos prémium", "Acción", "Aventura", "RPG", "Realidad Virtual", "Arcade", "Correr", "Deporte"];

            let index = englishCat.indexOf(cat.categoryName);
            if (index != -1) {
                if(lang=='ar'){
                    cat = { ...cat, categoryName: arabicCat[index] };
                }
                else if(lang=='kk'){
                    cat = { ...cat, categoryName: kazakhCat[index] };
                }
                else if (lang == 'fr'){
                    cat = { ...cat, categoryName: frenchCat[index] };
                }
                else if (lang == 'sv') {
                    cat = {...cat, categoryName: swedishCat[index] };
                }  
                else if (lang == 'be') {
                    cat = { ...cat, categoryName: belgiumCat[index] };
                } 
                else if (lang == 'no') {
                    cat = { ...cat, categoryName: norwayCat[index] };
                } 
                else if (lang == 'vi') {
                    cat = { ...cat, categoryName: vietnamCat[index] };
                } 
                else if (lang == 'tr') {
                    cat = { ...cat, categoryName: turkeyCat[index] };
                } 
                else if (lang == 'es') {
                    cat = { ...cat, categoryName: spanishCat[index] };
                } 
            }
            return cat;

        });
        return translatedCatArr;
    }

    getCategoryDetail(categoryId) {
        let allCategories = this.props.categories.categories;
        let foundCategory = allCategories.find(cat => {
            return (cat.categoryId == categoryId);
        })
        // let translatedCategory = this.translateCat(foundCategory);
        this.props.getCategoryDetail(foundCategory);
        this.setState({
            category: foundCategory
        })
        this.props.hide();
    }

    openGame(game, e) {
        if (e.target.classList.contains('isFavorite')) {
            let data = {
                uid: this.props.access.uid,
                gameId: game.gameId,
                isFavorite: !game.isFavorite
            };
            if(data.isFavorite){
                this.props.showMessage({
                    message: msg.addToFavorites,
                    type: true
                });
            }
            else{
                this.props.showMessage({
                    message: msg.removeFromFavorites,
                    type: false
                });
            }
            sendData(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' :'favorite-removed');
            axios.post(vars.BASE_URL + '/favorite', data)
                .then((response) => {
                    if (response.status) {
                        this.getGames(this.props.match.params.categoryId, this.props.access.uid)
                        .then(() => {

                        })
                        .catch(err => {
                            console.log(err);
                        })
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } else if (e.target.tagName.toLowerCase() != 'input') {
            this.props.history.push(appendUid('/detail/' + game.gameId, this.props.access.uid));
        }
    }
    changeLanguage(){
        switch (config.lang) {
            case 'ar': msg = messages_ar;
                break;
            case 'kk': msg = messages_kk;
                break;
            case 'fr': msg = messages_fr;
                break;
            case 'sv': msg = messages_sv;
                break;
            case 'no': msg = messages_no;
                break;
            case 'vi': msg = messages_vi;
                break;
            case 'tr': msg = messages_tr;
                break;
            case 'it': msg = messages_it;
                break;
            case 'es': msg = messages_es;
                break;
            case 'cy': msg = messages_cy;
                break;
            case 'de': msg = messages_de;
                break;
            case 'el': msg = messages_el;
                break;
            case 'cs': msg = messages_cz;
                break;
            case 'pt': msg = messages_pt;
                break;
            case 'lt': msg = messages_lt;
                break;    
            default: msg = messages;
                break;
        }
    }

    render() {
        const starIcon = '<svg class="isFavorite" width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.3328" y1="14" x2="25.6672" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.2078" y1="14" x2="25.7922" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="isFavorite" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"/></svg>',
        thumbsUpIcon = '<svg width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="0.5" y1="14" x2="24.5" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientUnits="userSpaceOnUse" x1="0.375" y1="14" x2="24.625" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="st0" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M320 1344q0-26-19-45t-45-19q-27 0-45.5 19t-18.5 45q0 27 18.5 45.5t45.5 18.5q26 0 45-18.5t19-45.5zm160-512v640q0 26-19 45t-45 19h-288q-26 0-45-19t-19-45v-640q0-26 19-45t45-19h288q26 0 45 19t19 45zm1184 0q0 86-55 149 15 44 15 76 3 76-43 137 17 56 0 117-15 57-54 94 9 112-49 181-64 76-197 78h-129q-66 0-144-15.5t-121.5-29-120.5-39.5q-123-43-158-44-26-1-45-19.5t-19-44.5v-641q0-25 18-43.5t43-20.5q24-2 76-59t101-121q68-87 101-120 18-18 31-48t17.5-48.5 13.5-60.5q7-39 12.5-61t19.5-52 34-50q19-19 45-19 46 0 82.5 10.5t60 26 40 40.5 24 45 12 50 5 45 .5 39q0 38-9.5 76t-19 60-27.5 56q-3 6-10 18t-11 22-8 24h277q78 0 135 57t57 135z"/></svg>';
        this.changeLanguage();
        let categoryName = this.state.category.categoryName;
        if (isGamiclub && config.subDomain === 'fr' && this.state.category.categoryId === 4) {
            categoryName = "Action (18+)";
        } 
        /*if(this.state.loading){ 
            return <div className='activity-indicator'> <img className={isGamiclub ? 'icon-loader-gamiclub' : 'icon-loader'} src={isGamiclub ? './img/ball-triangle.svg' : './img/g-icon.svg'} alt="Loading..."/></div>;
        }
        else {*/
            return (
                <section className="categoryListPage">
                    <div className="container-fluid">
                        <Row>
                            <Col xs="12">
                                <div className="game-category" style={isGamiclub ? {borderBottom: '1px solid green'}:isGameflares ? {borderBottom: '1px solid #FF394B'} : isGamiway ? {borderBottom : '1px solid #b347a0'}: null}>
                                <h2 style={isGamiclub ? {color: 'white', backgroundColor: 'green'} :isGameflares ? {color: 'white', backgroundColor: '#FF394B'} : isGamiway ? {color: 'white', backgroundColor:'#b347a0'}: null} className="game-category-title"><i className={(this.state.category) ? this.state.category.categoryIcon : "fa fa-rocket"} aria-hidden="true"></i>{(this.state.category) ? 
                                <FormattedMessage id={`${categoryName}`}
                                    defaultMessage={categoryName}
                                />:""}</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row className="game-list-row">
                            {(this.props.games.categoryGames.length > 0) ?
                                this.props.games.categoryGames.map((game) => {
                                    return (
                                        filterGames(game)?
                                        <Col xl="2" md="3" sm="4" xs="6" key={game.gameId}>
                                            <Card className={isGamiclub ? "game-card-gamiclub" : isGameflares ? " game-card gameflares-game-card": isGamiway  ? "game-card gamiway-card": "game-card"} onClick={this.openGame.bind(this, game)}>
                                                <div className="game-card-inner">
                                                    <div className="game-thumb-wrap">
                                                        <CardImg className="game-thumb" top width="100%" src={game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage} alt={game.gameTitle} />
                                                    </div>
                                                    <div className="game-card-details">
                                                        {config.subDomain != 'es' && <CardTitle className="game-title text-shadow">
                                                        <FormattedMessage id={`${game.gameTitle.toUpperCase()}`}
                                                             defaultMessage={game.gameTitle}/>
                                                            </CardTitle>}
                                                        {window.location.hostname.includes('vplay') ? null :     
                                                        <div className="custom-rating isFavorite">
                                                            <input id={'fav'+game.gameId} ref={'star'+game.gameId} className="isFavorite" type="checkbox" checked={game.isFavorite}/>
                                                            <label htmlFor={'fav'+game.gameId} className="isFavorite">
                                                                <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color:'#FF394B'} :  isGamiway ? {color:'#b347a0'}:null} className="fa fa-star-o custom-star isFavorite"></i>
                                                            </label>
                                                        </div>
                                                        }
                                                        {/*<StarRatingComponent className="abc isFavorite" name={'fav'+game.gameId} starCount={1} value={(game.isFavorite)? 1 : 0} editing={true} renderStarIcon={() => <i className="fa fa-star custom-star fa-gradient isFavorite"></i>} />*/}
                                                        <div className="game-card-left">
                                                            <StarRatingComponent name="rate1" starCount={5} value={game.userRating} editing={false} renderStarIcon={() => <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color:'#FF394B'} : isGamiway ? {color:'#b347a0'} : null} className="fa fa-star custom-star"></i>} />
                                                        </div>
                                                        {(!window.location.hostname.includes('vplay') && config.subDomain != 'es') && 
                                                        <div className="game-card-right text-uppercase text-shadow text-right">{(game.gameType.toLowerCase() == 'html5')?<i className="fa fa-html5" aria-hidden="true"></i>:(game.gameType.toLowerCase() === "android") ? <i className="fa fa-android" aria-hidden="true"></i> : <i className="fa fa-video-camera" aria-hidden="true"></i>}</div>}
                                                    
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>:null
                                    )
                                })
                                :<Col xl="12" lg="12" md="12" sm="12" xs="12"> <p className="white-text-color no-game-text">
                                    {window.location.hash.includes('home/video') ? <FormattedMessage id="noVideosFound" defaultMessage="No videos found under this category." /> 
                                    : <FormattedMessage id="noGamesFound" defaultMessage="No games found under this category." />}
                                </p></Col>
                            }
                        </Row>
                    </div>
                </section>
            )
        //}
    }
}

const mapStateToProps = (state) => {
    return {
        games: state.GamesReducer,
        categories: state.CategoryReducer,
        access: state.WelcomeReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getCategorygame,
        getCategoryDetail,
        showMessage
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(GameList);

























// WEBPACK FOOTER //
// ./src/components/GameDetail/GameList.js